import React, { Component } from "react";

import Api from "../../../../../lib/componentApi";
import getAppErrors from "../../../../../lib/appErrors";
import mixpanel from "../../../../../lib/mixPanel";

import Loading from "../../../../../components/Common/Loading";
import CommonHeader from "../../../../../components/Common/Header";

import SelectPayment from "../SelectPayment";
import OrderSubmitted from "./OrderSubmitted";
import StaticMap from "./StaticMap";

const stripeToken = process.env.STRIPE_TOKEN;

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultPayment: null,
      paymentDeclined: false,
      submitted: false,
      orderUid: "",
      loading: true,
      changePayment: false,
      allPayments: [],
      errorMessage: null,
      pointsEarned: 0,
      stripe: null,
      canMakePayment: false,
      paymentRequest: null
    };
  }

  componentDidMount() {
    if (window && window.Stripe && stripeToken) {
      const stripe = window.Stripe(stripeToken);

      const { confirmTotal } = this.props;
      if (stripe && confirmTotal) {
        const options = {
          country: "GB",
          currency: "gbp",
          total: {
            label: "Local E",
            amount: Math.round(confirmTotal * 100)
          }
        };
        const paymentRequest = stripe.paymentRequest(options);

        paymentRequest.canMakePayment().then(result => {
          this.setState({ canMakePayment: !!result });
        });
        this.setState({ paymentRequest, stripe });
      }
    }

    Api.get("/api/user/payments", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "checkout-payment-code");
      } else {
        if (response.creditCards && response.creditCards.length) {
          this.setState({
            defaultPayment: response.creditCards[0],
            allPayments: response.creditCards
          });
        } else if (this.state.canMakePayment) {
          const payment = this.getBrowserPayment();
          this.setState({
            defaultPayment: payment
          });
        }
        this.setState({ loading: false });
      }
    });
  }

  isMicrosoft = () => {
    const ua = window.navigator.userAgent;
    console.log(ua);
    const msie = ua.indexOf("MSIE ");
    const trident = ua.indexOf("Trident/");
    const edge = ua.indexOf("Edge/");
    if (msie > 0 || edge > 0 || trident > 0) {
      return true;
    }

    // other browser
    return false;
  };
  getBrowserPayment = () => {
    const isMicrosoft = this.isMicrosoft();
    let payment = null;
    if (window.ApplePaySession) {
      payment = "applePay";
    } else if (isMicrosoft) {
      payment = "microsoftPay";
    } else {
      payment = "googlePay";
    }
    return payment;
  };
  getType = () => {
    const isMicrosoft = this.isMicrosoft();
    let type = null;
    if (window.ApplePaySession) {
      type = 2;
    } else if (isMicrosoft) {
      type = 4;
    } else {
      type = 3;
    }
    return type;
  };
  getPayIcon = () => {
    const { defaultPayment } = this.state;
    if (defaultPayment === "applePay") {
      return (
        <div className="apple-pay-image">
          <img src={`/png/apple-pay.png`} />
        </div>
      );
    } else if (defaultPayment === "googlePay") {
      return (
        <div className="apple-pay-image">
          <img src={`/png/google-pay.png`} />
        </div>
      );
    } else if (defaultPayment === "microsoftPay") {
      return (
        <div className="apple-pay-image">
          <img src={`/png/microsoft-pay.png`} />
        </div>
      );
    } else {
      return (
        <>
          <div className="card-image">
            <img
              src={`/svg/payment/${defaultPayment.method.toLowerCase()}.svg`}
            />
          </div>
          <p>**** **** **** {defaultPayment.last4}</p>
        </>
      );
    }
  };
  renderPayWithSection = () => {
    const { defaultPayment } = this.state;
    const { confirmTotal } = this.props;
    if (defaultPayment) {
      return (
        <React.Fragment>
          <p>Pay With</p>
          <div className="checkout-v2-list">
            {(!confirmTotal && (
              <React.Fragment>
                <div className="local-wallet">
                  <i className="icon icon-wallet-white" />
                  <p className="hide-xs">Local E Wallet</p>
                </div>
                <p className="visible-xs">Local E Wallet</p>
                <a
                  className="cursor-pointer"
                  onClick={() => this.setState({ changePayment: true })}
                >
                  Change
                </a>
              </React.Fragment>
            )) || (
              <React.Fragment>
                {this.getPayIcon()}

                <a
                  className="cursor-pointer"
                  onClick={() => this.setState({ changePayment: true })}
                >
                  Change
                </a>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <p>Pay With</p>
          <div className="checkout-v2-list add-new-payment">
            <a
              className="cursor-pointer"
              onClick={() => this.setState({ changePayment: true })}
            >
              + Add a Payment Method
            </a>
            <i className="icon icon-arrow-3 visible-xs" />
          </div>
        </React.Fragment>
      );
    }
  };
  completeOrder = async e => {
    e.preventDefault();
    const { defaultPayment, paymentRequest, stripe } = this.state;
    const { basketData, confirmTotal, pointsAmount } = this.props;
    var self = this;
    if (defaultPayment) {
      if (
        defaultPayment === "applePay" ||
        defaultPayment === "microsoftPay" ||
        defaultPayment === "googlePay"
      ) {
        paymentRequest.on("token", async ({ complete, token }) => {
          const { source, error } = await stripe.createSource({
            type: "card",
            token: token.id
          });
          if (error) {
            complete("fail");
          } else {
            const payData = {
              paymentSourceType: this.getType(),
              paymentSourceToken: source.id,
              points: pointsAmount
            };
            Api.post(
              "/api/product/checkout/complete",
              payData,
              (response, errors) => {
                if (errors) {
                  complete("fail");
                  if (errors === 503) {
                    self.setState(() => {
                      throw errors;
                    });
                  } else {
                    console.log(errors);
                  }
                } else if (response.code) {
                  complete("fail");
                  const errorMessage = getAppErrors(response.code);
                  self.setState(
                    {
                      errorMessage:
                        (errorMessage && errorMessage.message) ||
                        response.message
                    },
                    () => {
                      self.setState({ paymentDeclined: true });
                    }
                  );
                } else {
                  if (response.status) {
                    localStorage.setItem("userCanRate", "true");
                    mixpanel.people.increment("Count of Purchases");
                    mixpanel.people.increment({
                      "Total Purchase": confirmTotal
                    });
                    mixpanel.people.set({ "Basket is empty": true });
                    mixpanel.people.set({ "Promo Applied": null });
                    mixpanel.track("Order Checkout", {
                      _amount: confirmTotal,
                      _restaurantName: basketData.restaurant.name,
                      _promotionCode: basketData.promoCode,
                      _paymentMethod: "Apple Pay",
                      _pointsUsed: pointsAmount
                    });
                    complete("success");
                    if (response.redirectUrl) {
                      window.location.href = response.redirectUrl;
                    } else {
                      self.setState({
                        submitted: true,
                        paymentDeclined: false,
                        orderUid: response.orderUid,
                        pointsEarned: response.pointsEarned
                      });
                    }
                  } else {
                    console.log(response, "response");
                  }
                }
              }
            );
          }
        });

        paymentRequest.show();
      } else {
        const data = {
          paymentSourceType: 1,
          paymentSourceToken: defaultPayment.uid,
          points: pointsAmount
        };
        this.setState({ loading: true });
        Api.post("/api/product/checkout/complete", data, (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            const errorMessage = getAppErrors(response.code);
            this.setState(
              {
                errorMessage:
                  (errorMessage && errorMessage.message) || response.message
              },
              () => {
                this.setState({ paymentDeclined: true });
              }
            );
          } else {
            if (response.status) {
              localStorage.setItem("userCanRate", "true");
              mixpanel.people.increment("Count of Purchases");
              mixpanel.people.increment({ "Total Purchase": confirmTotal });
              mixpanel.people.set({ "Basket is empty": true });
              mixpanel.people.set({ "Promo Applied": null });
              mixpanel.track("Order Checkout", {
                _amount: confirmTotal,
                _restaurantName: basketData.restaurant.name,
                _promotionCode: basketData.promoCode,
                _paymentMethod: (confirmTotal && "Credit Card") || "Point",
                _pointsUsed: pointsAmount
              });
              if (response.redirectUrl) {
                window.location.href = response.redirectUrl;
              } else {
                this.setState({
                  submitted: true,
                  paymentDeclined: false,
                  orderUid: response.orderUid,
                  pointsEarned: response.pointsEarned
                });
              }
            } else {
              console.log(response);
            }
          }
          this.setState({ loading: false });
        });
      }
    }
  };

  renderSubmittedSection = () => {
    const { basketData, points } = this.props;
    const { restaurant } = basketData;
    const { orderUid, pointsEarned } = this.state;
    return (
      <OrderSubmitted
        orderUid={orderUid}
        restaurantName={restaurant.name}
        pointsEarned={pointsEarned}
        points={points}
      />
    );
  };
  renderPaymentDeclineSection = () => {
    const { errorMessage } = this.state;
    return (
      <React.Fragment>
        <div>
          <div className="modal-bg" />
          <div className="modal">
            {/* Header */}
            <div className="head-general with-back payment-popup">
              <a href="javascript: void(0)" />
              <h4>Oops</h4>
              <a href="/checkout" className="close">
                <icon className="icon icon-close" />
              </a>
            </div>
            {/* Header */}
            <div className="modal-body">
              <div className="promo-error white-bg">
                <p>{errorMessage}</p>
              </div>
              <div className="use-buttons">
                <button
                  className="btn btn-blue"
                  onClick={() => (window.location.href = "/checkout")}
                >
                  Go back to order
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  onSubmitMethod = changedPayment => {
    if (changedPayment) {
      this.setState({ defaultPayment: changedPayment, changePayment: false });
    }
  };
  getMapUrl = () => {
    const { basketData } = this.props;
    const imgWidth = window.innerWidth;
    const address =
      (basketData.delivery && basketData.address) ||
      basketData.restaurant.address;
    const { lat, lon } = address ? address : null;
    const markerIcon = `${window.location.origin}/png/locationHome.png`;
    return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lon}&style=feature:poi|visibility:off&zoom=18&size=${imgWidth}x195&markers=icon:${markerIcon}|${lat},${lon}&&&key=AIzaSyDqIcW_O-zUO90BsNZQjed33BthNi19Egc`;
  };

  render() {
    const { basketData, confirmTotal } = this.props;
    const { address } = basketData;
    const { addressLine1, postalCode, title } = address || "";
    const {
      paymentDeclined,
      submitted,
      loading,
      defaultPayment,
      changePayment,
      allPayments,
      canMakePayment
    } = this.state;
    const date = new Date();
    const minutes = basketData.preparationTime || 0;
    const estimatedTime = new Date(date.getTime() + minutes * 60000);
    const formattedTime =
      (estimatedTime && estimatedTime.toString().split(" ")[4]) || "-";
    const mapUrl = this.getMapUrl();
    if (paymentDeclined) {
      return this.renderPaymentDeclineSection();
    } else if (submitted) {
      return this.renderSubmittedSection();
    } else {
      return (
        <React.Fragment>
          <div>
            <div className="modal-bg" />
            <div className="modal">
              <CommonHeader className="payment-popup" />
              <div className="check-out-2 mt-10px">
                {(loading && <Loading />) || <noscript />}
                {(changePayment && (
                  <SelectPayment
                    payments={allPayments}
                    type={this.getType()}
                    canMakePayment={canMakePayment}
                    onSubmitMethod={this.onSubmitMethod}
                    onCloseSelectPayment={() =>
                      this.setState({ changePayment: false })
                    }
                  />
                )) || (
                  <React.Fragment>
                    {/* Header */}
                    <div className="head-general with-back hide-xs">
                      <a href="javascript: void(0)" />
                      <h4>Check out</h4>
                      <a href="/checkout" className="close">
                        <icon className="icon icon-close" />
                      </a>
                    </div>
                    {/* Header */}
                    <div className="modal-body">
                      <div className="total d-flex align-items-center justify-content-between">
                        <p>Total: </p>
                        <p>£{parseFloat(confirmTotal).toFixed(2)}</p>
                      </div>
                      {mapUrl && <StaticMap mapUrl={mapUrl} />}
                      <div className="white-bg body mt-10px">
                        <div className="d-flex align-items-center justify-content-between">
                          <div>
                            <p>Deliver to {title || addressLine1} ASAP!</p>
                            <p className="bold">
                              {(title && postalCode) ||
                                `${addressLine1} - ${postalCode}`}
                            </p>
                            <p>Estimated time {formattedTime}</p>
                          </div>
                          <div className="visible-xs">
                            <div className="svg-icon">
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="10"
                                  viewBox="0 0 14 10"
                                >
                                  <path
                                    fill="#FFF"
                                    fillRule="evenodd"
                                    d="M4.167 10c.334 0 .648-.131.883-.37l8.04-8.193a.849.849 0 0 0 0-1.19.828.828 0 0 0-1.179 0L4.167 8.143 1.423 5.246a.828.828 0 0 0-1.179 0 .847.847 0 0 0 0 1.19l3.039 3.195c.237.238.549.369.884.369z"
                                  />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="visible-xs pay-earn-point">
                          You’ll earn{" "}
                          <span className="bold color-blue">
                            {basketData.pointsEarned} eCoins
                          </span>
                        </div>
                      </div>

                      <div className="white-bg payment mt-10px">
                        {this.renderPayWithSection()}
                      </div>
                      <div className="fixed-btn checkout-btn">
                        <button
                          disabled={!defaultPayment}
                          className={(defaultPayment && "active") || ""}
                          onClick={this.completeOrder}
                        >
                          <span>Complete Order</span>
                        </button>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
              {/* .modal-body */}
            </div>
            {/* .modal */}
          </div>
        </React.Fragment>
      );
    }
  }
}

export default Payment;
